export var ClientSharedValues = {
    lstatSync: function () { },
};
